import {
  FETCH_RESOURCES_REQUEST,
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCES_FAILURE,
  CREATE_RESOURCE_REQUEST,
  CREATE_RESOURCE_SUCCESS,
  CREATE_RESOURCE_FAILURE,
  UPDATE_RESOURCE_REQUEST,
  UPDATE_RESOURCE_SUCCESS,
  UPDATE_RESOURCE_FAILURE,
  DELETE_RESOURCE_REQUEST,
  DELETE_RESOURCE_SUCCESS,
  DELETE_RESOURCE_FAILURE,
} from "../actions/types";

const initialState = {
  resources: [],
  loading: false,
  error: null,
  message: "",
};

const resourceReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case FETCH_RESOURCES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_RESOURCES_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: action.payload,
        message: "Resources loaded successfully",
      };

    case FETCH_RESOURCES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        resources: [],
      };


    case CREATE_RESOURCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_RESOURCE_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: [action.payload, ...state.resources], 
        message: "Resource created successfully",
      };

    case CREATE_RESOURCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case UPDATE_RESOURCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_RESOURCE_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: state.resources.map((resource) =>
          resource.resource_id === action.payload.resource_id
            ? action.payload
            : resource
        ),
        message: "Resource updated successfully",
      };

    case UPDATE_RESOURCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_RESOURCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_RESOURCE_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: state.resources.filter(
          (resource) => resource.resource_id !== action.payload
        ),
        message: "Resource deleted successfully",
      };

    case DELETE_RESOURCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default resourceReducer;